
import React from "react";

interface ColorSquareIconProps {
  className?: string;
  size?: number;
  color?: string;
}

const ColorSquareIcon: React.FC<ColorSquareIconProps> = ({ 
  className = "", 
  size = 18,
  color = "#ccc"
}) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 18 18" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <rect 
        x="0" 
        y="0" 
        width="18" 
        height="18" 
        rx="6" 
        fill={color}
      />
    </svg>
  );
};

export default ColorSquareIcon;
